export default {
    ja: {
        collabo: {
            heading: 'COLLABORATION',
            readMore: '続きを読む',
            sold_out: '販売終了しました',
            close: '閉じる',
            external: '公式サイト',
            items: [
                {
                    id: 'clb-01',
                    subtitle: '',
                    title: 'NAKEDディスタンス提灯®セットチケット',
                    description: '入場券に大人気のNAKEDディスタンス提灯®のレンタルができるセットチケット',
                    price: '販売価格：大人2,500円\n小人1,500円',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'チケット購入はこちら', link: 'https://www.asoview.com/channel/ticket/VoDeZvmuPm/ticket0000044408/', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-02',
                    label: '法師宿泊者限定',
                    subtitle: '',
                    title: '宿泊プラン付きVIP拝観チケット',
                    description: '北陸最古の旅館として知られている「粟津温泉 法師」とコラボレーションが今年も決定！宿泊者限定の特典として会場前の1時間（16:00－17:00）に会場に入ることができ、那谷寺の僧侶によるガイドが付く特別拝観です。また、能登牛やのど黒など石川の食材を活かした懐石に、日本酒飲み比べコースがついた宿泊プランも登場。VIP拝観チケットは一人5,000円、温泉付き特別室の宿泊プランの費用については法師ホームページよりご確認ください。',
                    price: '',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: '予約は法師公式サイトから', link: 'https://reserve.489ban.net/client/ho-shi/0/plan/id/229168/stay?noSearch=1', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-03',
                    subtitle: '',
                    title: 'VIP拝観チケット',
                    description: '通常非公開の国指定名勝「庫裡庭園」や重要文化財「書院及び庫裏」を、僧侶やスタッフのガイド付きで特別に公開。また、一般入場より早い特別時間帯（16:00〜17:00）に那谷寺を訪れることが可能です。黄昏から宵へ移ろうひととき、加賀藩ゆかりの建築美と庭園美を間近に体感できる、VIP拝観チケットだけの特別な体験です。',
                    price: '販売価格：5,000円',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'チケット購入はこちら', link: 'https://www.asoview.com/channel/ticket/VoDeZvmuPm/ticket0000044422/', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-04',
                    subtitle: '',
                    title: '世界に一つの石アクセサリーワークショップ',
                    description: '小松の石を利用したワークショップを登録文化財「普門閣」で開催。欅造りの歴史的建造物で小松の地域資源を用い自分だけの作品を製作。石工の伝統が息づく小松の地で、身近なクラフトを通じて石の魅力を再発見。お子さまから大人まで楽しめる、地域資源を生かした体験です。\n' +
                        '・販売価格：2,000円（税込）\n' +
                        '・時間帯：イベント開催中（17:00~20:30まで）\n' +
                        '・予約制：1日20名様 限定',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'チケット購入はこちら', link: 'https://www.asoview.com/channel/ticket/VoDeZvmuPm/ticket0000044423/', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-05',
                    subtitle: '',
                    title: '写経奉納・瞑想の精神性体験\n' +
                        '「石の聖地で、心を澄ますひととき」',
                    description: '登録文化財「普門閣」で黄昏から宵へ移ろう静寂の時間帯を活かし、文化と内省の価値を体感する。\n' +
                        '古来より受け継がれる写経を体験し、その文字を奉納することで、自分の想いを歴史と未来へとつなぎます。\n' +
                        '写経と奉納、そして瞑想体験を通じて、心を整えるひとときを提供。\n' +
                        '・販売価格：5,000円（税込）\n' +
                        '・時間帯：イベント開催前（16:00~17:00まで）\n' +
                        '・予約制：1日10名様 限定',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'チケット購入はこちら', link: 'https://www.asoview.com/channel/ticket/VoDeZvmuPm/ticket0000044414/', disabled: false, class: '' },
                    ],
                    visible: true,
                },
            ],
        },
    },
    en: {
        collabo: {
            heading: 'COLLABORATION',
            readMore: 'Show more',
            sold_out: 'Sold Out',
            close: 'Close',
            external: '公式サイト',
            items: [
                {
                    id: 'clb-01',
                    subtitle: '',
                    title: 'NAKED Distance Lantern®\n Rental Set Ticket',
                    description: 'A combo ticket that includes admission and rental of the popular NAKED Distanced Lantern®',
                    price: 'Price：Adult (Junior high school\n students and older)\n2,500JPY\nChild (Elementary school \nstudents)\n1,500JPY',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'KKday', link: 'https://www.kkday.com/en-us/product/195567', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-02',
                    label: 'For registered hotel guests only',
                    subtitle: '',
                    title: 'VIP Admission Ticket with Accommodation Plan',
                    description: 'This is a special accommodation plan in collaboration with Hoshi, the oldest inn in the Hokuriku region.\n' +
                        'As an exclusive benefit for guests, you will have VIP access to the temple grounds during a private viewing hour (16:00–17:00), when no general visitors are present.\n' +
                        'At twilight, you can enjoy the illuminated autumn leaves and take part in an exclusive guided tour of the grounds, led by the chief priest or monks, in a small, intimate group.\n'+'\n'+
        'For accommodation plans, please check the Hoshi website.',
                    price: '',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'Hoshi website', link: 'https://reserve.489ban.net/client/ho-shi/0/plan/id/229168/stay?noSearch=1', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-03',
                    subtitle: '',
                    title: 'VIP temple visit',
                    description: 'Enjoy a guided tour of the nationally designated Place of Scenic Beauty, the "Kuri Garden," and the Important Cultural Property, the "Shoin and Kuri," both normally closed to the public. This VIP ticket also grants early entry to Natadera Temple (16:00–17:00), before general admission begins. As twilight turns to evening, experience up close the exquisite architecture and gardens associated with the Kaga Domain—an unforgettable opportunity available only with the VIP Admission Ticket.',
                    price: '5,000JPY',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'KKday', link: 'https://www.kkday.com/en/product/195567?cid=13044&ud1=officialwebsite', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-04',
                    subtitle: 'Fumonkaku (House of Sutras), Houmotsukan',
                    title: 'Stone Accessory Workshop in Komatsu\n' +
                        '"Create a One-of-a-Kind Stone Accessory in a Historic Cultural Setting"',
                    description: 'Join a hands-on workshop at Fumonkaku, a Registered Tangible Cultural Property, where you can create your very own accessory using Komatsu\'s locally sourced stone. Inside this historic wooden structure, you\'ll rediscover the charm of Komatsu stone through crafting that reflects the region\'s rich stonemasonry tradition.\n' +
                        'This family-friendly activity is open to both children and adults, offering a fun and meaningful way to engage with local heritage.\n' + '\n' +

                        '・Fee: workshop+Adult Ticket\n' +
                        '4,000JPY (tax included)\n' +
                        'workshop+Child  Ticket\n' +
                        '3,000JPY (tax included)\n' + '\n' +

                        '・Time: During event hours (5:00 PM – 8:30 PM)\n' +
                        '・Capacity: Limited to 20 participants per day (advance reservation required)',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'KKday', link: 'https://www.kkday.com/en-us/product/195567', disabled: false, class: '' },
                    ],
                    visible: true,
                },
                {
                    id: 'clb-05',
                    subtitle: 'Fumonkaku (House of Sutras), Houmotsukan',
                    title: 'Sutra Copying and Meditation: A Spiritual Experience in the Sacred Land of Stone',
                    description: 'At Fumonkaku, a Registered Tangible Cultural Property, experience the quiet transition from dusk to night as you immerse yourself in practices of culture and contemplation.\n' +
                        'Engage in the ancient tradition of shakyo (sutra copying), dedicating your handwritten scripture as a symbolic connection between the past, present, and future. Through copying, offering, and meditation, you will find a moment to clear your mind and realign your spirit in a sacred atmosphere.\n' + '\n' +

                        '・Fee: sutra copying+ticket 5,000JPY (tax included)\n' +
                        '・Time: Before the main event (4:00 PM – 5:00 PM)\n' +
                        '・Capacity: Limited to 10 participants per day (advance reservation required)',
                    note: '',
                    showTitle: true,
                    showSubtitle: true,
                    links: [
                        { title: 'KKday', link: 'https://www.kkday.com/en-us/product/195567', disabled: false, class: '' },
                    ],
                    visible: true,
                },
            ],
        },
    },
};

// idごとに対応する画像パスを定義
const imagePathsMapping = {
    'clb-01': 'Images/set/clb-01_lantern.webp',
    'clb-02': 'Images/set/clb-02_hoshiviphaikan.webp',
    'clb-03': 'Images/set/clb-03_vip.webp',
    'clb-04': 'Images/set/clb-04_workshop2.webp',
    'clb-05': 'Images/set/clb-05_syakyo.webp',
};

// 画像キャッシュ無効化用のバージョン
const IMAGE_VERSION = '2025-09-19-v2';

// セットベースの順序制御システム
const setOrder = {
    'set-1': {
        order: 1,
        largeIndices: [0], // 0番目のカードがlarge
        cards: [
            { id: 'clb-01' },
            { id: 'clb-02' },
            { id: 'clb-03' },
            { id: 'clb-04' },
            { id: 'clb-05' },
        ]
    }
};

export { imagePathsMapping, setOrder, IMAGE_VERSION };